/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { subtypereference } from 'projects/icemedx-lib/src/models/ehr/subs/subtypereference';

export class observation extends IceEntity {
	observation_key: string = "";
  observation_date: any = NaN;
  description: string = "";
  severity_type: number = 0;
  mood_code: string = "";
  observation_type: IceTypes.observationtype = IceTypes.observationtype.observTypeSymptom;
  record_version: number = 0;
  offline_record_status: number = 0;
  obx2_value_type: string = "";
  obx3_observation_id_file_name: string = "";
  obx4_observation_subid: string = "";
  obx5_observation_value: string = "";
  obx6_units: string = "";
  obx7_references_range: string = "";
  obx8_abnormal_flags: string = "";
  obx9_probability: string = "";
  obx10_nature_of_abnormal_test: string = "";
  obx11_observation_result_status: string = "";
  obx12_effective_date_of_reference_range: any = NaN;
  obx13_userdefined_access_checks: string = "";
  obx14_datetime_of_the_observation: any = NaN;
  obx15_producers_reference: string = "";
  obx16_responsible_observer: string = "";
  obx17_observation_method: string = "";
  obx18_equipment_instance_identifier: string = "";
  obx19_datetime_of_the_analysis: any = NaN;
  obx23_performing_organization_name: string = "";
  obx24_performing_organization_address: string = "";
  obx25_performing_organization_medical_director: string = "";
  nte2_source_of_comment: string = "";
  nte4_comment_type: string = "";
  // Note: Added these fields. Not sure whether these fields are required in this model.
  modified: any = NaN;
  modified_user: string = "";
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";

  SUBTYPES: subtypereference[] = [];

  gettablename(): string {
    return "OBSERVATION";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "EXTDATAREFS") return true;
    else if (ColumnName == "SUBTYPES") return true;
    
    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "EXTDATAREFS") return "EXTERNAL_DATA_REFERENCE";
    else if (ColumnName == "SUBTYPES") return "SUB_TYPE_REFERENCE";

    return null;
  }
}
